import { render, staticRenderFns } from "./DirectQuestionsCard.vue?vue&type=template&id=2446c434&scoped=true&"
import script from "./DirectQuestionsCard.vue?vue&type=script&lang=js&"
export * from "./DirectQuestionsCard.vue?vue&type=script&lang=js&"
import style0 from "./DirectQuestionsCard.vue?vue&type=style&index=0&id=2446c434&prod&scoped=true&lang=css&"
import style1 from "./DirectQuestionsCard.vue?vue&type=style&index=1&id=2446c434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446c434",
  null
  
)

export default component.exports